import { Heading, SimpleGrid } from '@chakra-ui/react';
import PostPreview from './PostPreview';
import type { Post } from '../../libs/sanity.queries';

export default function MoreStories({ posts }: { posts: Post[] }) {
  return (
    <section>
      <Heading
        as='h2'
        size='xl'
        fontSize={{ base: '2xl', md: '6xl' }}
        my={8}
        fontWeight='bold'
        className='leading-tight tracking-tighter'
      >
        More Posts
      </Heading>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
        {posts.map((post) => (
          <PostPreview
            // eslint-disable-next-line no-underscore-dangle
            key={post._id}
            title={post.title}
            coverImage={post.mainImage}
            date={post.date}
            author={post.author}
            slug={post.slug}
            excerpt={post.description}
          />
        ))}
      </SimpleGrid>
    </section>
  );
}
